export const SIGN_DOCUMENTS_ACTION_MODAL = 'SignDocumentsActionModal' as const;
export const VIEW_SIGNED_DOCUMENTS_MODAL = 'ViewSignedDocumentModal' as const;
export const VIEW_GUARANTOR_AGREEMENT_MODAL =
    'ViewGuarantorAgreementModal' as const;
export const ADD_PAYMENT_METHOD_MODAL = 'AddPaymentMethodModal' as const;
export const EDIT_PAYMENT_METHOD_MODAL = 'EditPaymentMethodModal' as const;
export const REPAYMENT_SCHEDULE_MODAL = 'RepaymentScheduleModal' as const;
export const LOAN_BUILDER_REPAYMENT_SCHEDULE_MODAL =
    'LoanBuilderRepaymentScheduleModal' as const;
export const PERSON_MODAL = 'PersonModal' as const;
export const PROCESSING_PAYMENT_MODAL = 'ProcessingPaymentModal';
export const APPLICANT_CALL_MODAL = 'ApplicantCallModal';
export const MANUAL_PAYMENT_MODAL = 'ManualPaymentModal';
export const TIMEOUT_SESSION_ERROR_MODAL = 'TimeoutSessionErrorModal';
export const FALLBACK_ERROR_MODAL = 'FallbackErrorModal';
export const UPLOAD_DOCUMENTS_MODAL = 'UploadDocumentsModal';
export const UNLINK_LINKED_ACCOUNT_MODAL = 'UnlinkLinkedAccountModal';
export const IDENTITY_QUESTION_MODAL = 'IdentityQuestionModal';
export const ONFIDO_VERIFICATION_MODAL = 'OnfidoVerificationModal';
export const LINK_OPEN_BANKING_MODAL = 'LinkOpenBankingModal';
export const ID_NOW_MODAL = 'IDNowModal';
export const HELP_MODAL = 'HelpModal';
export const RELINK_BANKING_MODAL = 'relinkBankingModal';
export const RELINK_EXPIRED_BANKING_MODAL = 'relinkExpiredBankingModal';
export const CROSS_SELL_WARNING_MODAL = 'crossSellWarningModal';
